<template>
  <div class="settings-mask" @click.self="$emit('close')">
    <section ref="dialog" class="settings-panel" role="dialog" aria-modal="true" aria-label="Ai助理设置" @keydown.esc.stop="$emit('close')" @keydown.tab="trapFocus">
      <header><h2>Ai助理设置</h2><button ref="close" aria-label="关闭设置" @click="$emit('close')">×</button></header>
      <label class="settings-row"><span><strong>显示悬浮入口</strong><small id="ai-entry-setting-help">打开后将在控制页面右下角显示Ai助理入口</small></span><ui-toggle v-model="visible" aria-label="显示悬浮入口" aria-describedby="ai-entry-setting-help" @change="save" /></label>
      <label class="settings-row"><span><strong>语音直接发送</strong><small id="ai-voice-setting-help">打开后语音识别文字会直接发送</small></span><ui-toggle v-model="directSend" aria-label="语音直接发送" aria-describedby="ai-voice-setting-help" @change="saveVoice" /></label>
    </section>
  </div>
</template>
<script>
import UiToggle from '@/components/common/ui-toggle.vue'
import { entryVisible, setEntryVisible, voiceDirectSend, setVoiceDirectSend } from '@/ai/state/preferences'
// 只管理本地交互偏好，复用原账号存储键；不影响菜单入口、会话或服务权限。
export default {
  components: { UiToggle },
  data: () => ({ visible: entryVisible(), directSend: voiceDirectSend() }),
  mounted() { this.$refs.close.focus() },
  methods: {
    save() { setEntryVisible(this.visible) },
    saveVoice() { setVoiceDirectSend(this.directSend) },
    trapFocus(event) {
      const nodes = Array.from(this.$refs.dialog.querySelectorAll('button:not(:disabled),input:not(:disabled)'))
      const index = nodes.indexOf(document.activeElement)
      if (event.shiftKey && index <= 0) { event.preventDefault(); nodes[nodes.length - 1].focus() }
      else if (!event.shiftKey && (index === nodes.length - 1 || index < 0)) { event.preventDefault(); nodes[0].focus() }
    }
  }
}
</script>
<style scoped>
.settings-mask{position:fixed;inset:0;background:#1c26321c;display:flex;align-items:flex-end;padding:20px 20px 20px 68px;box-sizing:border-box;z-index:11000}
.settings-panel{width:360px;max-width:100%;max-height:80vh;overflow:auto;box-sizing:border-box;padding:24px;border:1px solid #e9ecf1;border-radius:22px;background:#fff;box-shadow:0 14px 50px #1d2c3d24;color:#606977}
header{display:flex;align-items:center;justify-content:space-between;gap:12px}h2{margin:0;font-size:15px;font-weight:600;color:#292f39}header button{width:28px;min-height:28px;padding:0;border:0;background:transparent;border-radius:50%;font-size:22px;color:#8a93a1;cursor:pointer}header button:hover{background:#f2f4f7}
.settings-row{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:20px 0 0;cursor:pointer}.settings-row>span{min-width:0}.settings-row strong{display:block;font-size:14px;font-weight:500;color:#303c50}.settings-row small{display:block;margin-top:6px;font-size:12px;color:#7b8494;line-height:1.6;overflow-wrap:anywhere}
button:focus-visible{outline:2px solid #8275d7;outline-offset:3px}
@media(max-width:700px){.settings-mask{padding:12px 12px max(12px,env(safe-area-inset-bottom))}.settings-panel{width:100%;max-width:380px;margin:0 auto;padding:20px}}
</style>
